export default __webpack_public_path__ + "static/Lamb-hot-Raw-7c8c9a9cce1fb4fc9292d9dfac3fbefe.png";